import * as React from 'react';
import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    border: '1px solid #eeecec',
    '& .MuiCardHeader-root': {
        '& .MuiCardHeader-title': {
            [theme.breakpoints.down('sm')]: {
                display: 'none',
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block',
            },
        },
        '& .MuiCardHeader-avatar': {
            marginRight: 0,
        },
        '& .MuiCardHeader-action': {
            marginRight: 0,
            '& .MuiButton-root': {
                // button styles here
            },
        }
    },
    '& .MuiCardContent-root': {
        // content styles here
    }
}));

export const GeneralCard = ({ children, styles, sx, width, ...rest }) => {
    // Width mapping
    const getWidthSx = (width) => {
        const widthMap = {
            'xs': { maxWidth: 'xs' },
            'sm': { maxWidth: 'sm' },
            'md': { maxWidth: 'md' },
            'lg': { maxWidth: 'lg' },
            'xl': { maxWidth: 'xl' },
            'full': { maxWidth: '100%' },
            'auto': { maxWidth: 'auto' }
        };
        return widthMap[width] || {};
    };

    return (
        <StyledCard
            {...rest}
            sx={[
                getWidthSx(width),
                styles, 
                sx
            ]} // ✅ width + styles + sx merge ho jayenge
        >
            {children}
        </StyledCard>
    );
};
